export default __webpack_public_path__ + "static/sowos-pocket-phone-a479a760917cfb2ff26caa0cc80278ba.svg";